import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('AbstractPerson')

export default {
  label: 'Externe Person',
  route: 'abstractperson',
  className: 'abstractPerson', // wird von fob-js-client benutzt
  fields: [
    ListFields.SortableField('vorname', true),
    ListFields.SortableField('name', true),
    ListFields.UnsortableReference('personIdent', false)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/AbstractPerson.js